import { useMarketAnalysisSectionContent } from './useMarketAnalysisSectionContent';
import { parseMarketAnalysisMarketInsightsContent } from '../utils/marketAnalysisContent';

export const useMarketAnalysisMarketInsightsContent = () =>
  useMarketAnalysisSectionContent(parseMarketAnalysisMarketInsightsContent);
